import { TransferPricingDocumentationRequestHelper } from './transfer-pricing-documentation-request-helper';
import type { TTransferPricingDocumentationMutationResult } from './types';

const FALLBACK_ERROR_MESSAGE = 'Could not delete the record. Please try again.';

export const deleteTransferPricingDocumentation = (
  documentationId: string
): Promise<TTransferPricingDocumentationMutationResult<null>> =>
  TransferPricingDocumentationRequestHelper.send({
    path: TransferPricingDocumentationRequestHelper.recordPath(documentationId),
    method: 'DELETE',
    isExpectedBody: (body: unknown): body is null => body === null,
    fallbackErrorMessage: FALLBACK_ERROR_MESSAGE,
  });
